module.exports = __webpack_public_path__ + "static/media/clock-hover.d52c1dfb.svg";